import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';

export const AvailabilityLabelWrapper = styled(Typography).attrs({
  variant: 'body3',
})`
  width: 100%;
  height: 3.6rem;
  margin: 0;
  ${({ theme, noMargin }) =>
    !noMargin && theme.getFluidSpacing('margin-bottom', 'equal', 3)};
  padding: 0 2.4rem;
  background-color: ${({ isRed }) =>
    getThemeColor(isRed ? 'hue.red' : 'hue.orange')};
  color: ${getThemeColor('grey.100')};
  line-height: 3.6rem;
`;
